/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashbackShow_cashback$ref = any;
type FastCashContainer_fastCash$ref = any;
export type DeleteCashbackInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type deleteCashbackMutationVariables = {|
  input: DeleteCashbackInput,
  byAuth0Id: string,
  afterDate: any,
  beforeDate: any,
  bankAccountIdEq: string,
  stateEq?: ?string,
  storeIdEq?: ?string,
  integrationItemIdEq?: ?number,
  nameCont?: ?string,
  byMerchantNames?: ?string,
  nameNotIContAll?: ?string,
|};
export type deleteCashbackMutationResponse = {|
  +deleteCashback: ?{|
    +errorMessage: ?string,
    +destroyedCashbackId: ?string,
    +fastCash: ?{|
      +$fragmentRefs: FastCashContainer_fastCash$ref
    |},
    +cashback: ?{|
      +$fragmentRefs: CashbackShow_cashback$ref
    |},
  |}
|};
export type deleteCashbackMutation = {|
  variables: deleteCashbackMutationVariables,
  response: deleteCashbackMutationResponse,
|};
*/


/*
mutation deleteCashbackMutation(
  $input: DeleteCashbackInput!
  $byAuth0Id: String!
  $afterDate: Date!
  $beforeDate: Date!
  $bankAccountIdEq: String!
  $stateEq: String
  $storeIdEq: String
  $integrationItemIdEq: Int
  $nameCont: String
  $byMerchantNames: String
  $nameNotIContAll: String
) {
  deleteCashback(input: $input) {
    errorMessage
    destroyedCashbackId
    fastCash(byAuth0Id: $byAuth0Id) {
      ...FastCashContainer_fastCash
      id
    }
    cashback {
      ...CashbackShow_cashback
      id
    }
  }
}

fragment BankAccountCell_bankAccount on BankAccount {
  id
  plaidAccountId
  mask
  name
  officialName
  accountSubtype
  accountType
  originalBankAccount {
    id
    ownerAuth0Id
    plaidAccountId
  }
  duplicationState
  availableDuplicationStates
  bankAccountsWithMask {
    id
  }
  integrationItem {
    institutionName
    id
  }
}

fragment CashbackCell_cashback on Cashback {
  id
  date
  name
  rate
  place
  storeId
  amount
  source
  plaidTransactionId
  transactionAmount
  state
  quarantinedReason
  availableStates
}

fragment CashbackShow_cashback on Cashback {
  id
  date
  name
  rate
  amount
  source
  pended
  plaidTransactionId
  transactionAmount
  fastCashId
  state
  quarantinedReason
  availableStates
  userAuth0Id
}

fragment FastCashContainer_fastCash on FastCash {
  id
  lifetimeCash
  availableCash
  pendingCash
  specialCashbackRate {
    id
    fastCashId
    userId
    comment
    state
    cashbackRate
    createdAt
    updatedAt
    deletedAt
  }
  firstOnboardedAt
  blockedState
  transactionsData(afterDate: $afterDate, beforeDate: $beforeDate, stateEq: $stateEq, bankAccountIdEq: $bankAccountIdEq, storeIdEq: $storeIdEq, integrationItemIdEq: $integrationItemIdEq, nameCont: $nameCont, byMerchantNames: $byMerchantNames, nameNotIContAll: $nameNotIContAll) {
    transactionsCount
    depositsAmount
    expensesAmount
  }
  cashbacksData(afterDate: $afterDate, beforeDate: $beforeDate) {
    netCashbacksAmount
    spentCashbacksAmount
    earnedCashbacksAmount
    refundCashbacksAmount
  }
  integrationItems {
    id
    institutionName
    itemId
    state
    errorCode
    accountOnboardedAt
  }
  user {
    email
    referrer {
      fullName
      auth0Id
      id
    }
    invitedUsers {
      auth0Id
      fullName
      id
    }
    id
  }
  cashbacks(afterDate: $afterDate, beforeDate: $beforeDate) {
    id
    name
    amount
    state
    date
    quarantinedReason
    availableStates
    storeId
    place
    ...CashbackCell_cashback
  }
  bankAccounts {
    id
    name
    duplicationState
    plaidAccountId
    availableDuplicationStates
    bankAccountsWithMask {
      id
    }
    integrationItem {
      institutionName
      id
    }
    ...BankAccountCell_bankAccount
  }
  checkIns(afterDate: $afterDate, beforeDate: $beforeDate) {
    id
    createdAt
  }
  latestMembershipState
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCashbackInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "byAuth0Id",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "beforeDate",
    "type": "Date!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bankAccountIdEq",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stateEq",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIdEq",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationItemIdEq",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nameCont",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "byMerchantNames",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nameNotIContAll",
    "type": "String"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destroyedCashbackId",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "byAuth0Id",
    "variableName": "byAuth0Id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fastCashId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "afterDate",
  "variableName": "afterDate"
},
v10 = {
  "kind": "Variable",
  "name": "beforeDate",
  "variableName": "beforeDate"
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "institutionName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auth0Id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quarantinedReason",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableStates",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidTransactionId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionAmount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCashbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCashbackPayload",
        "kind": "LinkedField",
        "name": "deleteCashback",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "FastCash",
            "kind": "LinkedField",
            "name": "fastCash",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FastCashContainer_fastCash"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Cashback",
            "kind": "LinkedField",
            "name": "cashback",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CashbackShow_cashback"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCashbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCashbackPayload",
        "kind": "LinkedField",
        "name": "deleteCashback",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "FastCash",
            "kind": "LinkedField",
            "name": "fastCash",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lifetimeCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "availableCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pendingCash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SpecialCashback",
                "kind": "LinkedField",
                "name": "specialCashbackRate",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "comment",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cashbackRate",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstOnboardedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "blockedState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "bankAccountIdEq",
                    "variableName": "bankAccountIdEq"
                  },
                  (v10/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "byMerchantNames",
                    "variableName": "byMerchantNames"
                  },
                  {
                    "kind": "Variable",
                    "name": "integrationItemIdEq",
                    "variableName": "integrationItemIdEq"
                  },
                  {
                    "kind": "Variable",
                    "name": "nameCont",
                    "variableName": "nameCont"
                  },
                  {
                    "kind": "Variable",
                    "name": "nameNotIContAll",
                    "variableName": "nameNotIContAll"
                  },
                  {
                    "kind": "Variable",
                    "name": "stateEq",
                    "variableName": "stateEq"
                  },
                  {
                    "kind": "Variable",
                    "name": "storeIdEq",
                    "variableName": "storeIdEq"
                  }
                ],
                "concreteType": "TransactionsData",
                "kind": "LinkedField",
                "name": "transactionsData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transactionsCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "depositsAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expensesAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "CashbacksData",
                "kind": "LinkedField",
                "name": "cashbacksData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "netCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spentCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "earnedCashbacksAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refundCashbacksAmount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationItem",
                "kind": "LinkedField",
                "name": "integrationItems",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "itemId",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "errorCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountOnboardedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "referrer",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "invitedUsers",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v13/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "Cashback",
                "kind": "LinkedField",
                "name": "cashbacks",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "place",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "bankAccounts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicationState",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableDuplicationStates",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "bankAccountsWithMask",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationItem",
                    "kind": "LinkedField",
                    "name": "integrationItem",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mask",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "officialName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountSubtype",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "originalBankAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ownerAuth0Id",
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "CheckIn",
                "kind": "LinkedField",
                "name": "checkIns",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "latestMembershipState",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Cashback",
            "kind": "LinkedField",
            "name": "cashback",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v17/*: any*/),
              (v15/*: any*/),
              (v20/*: any*/),
              (v16/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pended",
                "storageKey": null
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userAuth0Id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteCashbackMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCashbackMutation(\n  $input: DeleteCashbackInput!\n  $byAuth0Id: String!\n  $afterDate: Date!\n  $beforeDate: Date!\n  $bankAccountIdEq: String!\n  $stateEq: String\n  $storeIdEq: String\n  $integrationItemIdEq: Int\n  $nameCont: String\n  $byMerchantNames: String\n  $nameNotIContAll: String\n) {\n  deleteCashback(input: $input) {\n    errorMessage\n    destroyedCashbackId\n    fastCash(byAuth0Id: $byAuth0Id) {\n      ...FastCashContainer_fastCash\n      id\n    }\n    cashback {\n      ...CashbackShow_cashback\n      id\n    }\n  }\n}\n\nfragment BankAccountCell_bankAccount on BankAccount {\n  id\n  plaidAccountId\n  mask\n  name\n  officialName\n  accountSubtype\n  accountType\n  originalBankAccount {\n    id\n    ownerAuth0Id\n    plaidAccountId\n  }\n  duplicationState\n  availableDuplicationStates\n  bankAccountsWithMask {\n    id\n  }\n  integrationItem {\n    institutionName\n    id\n  }\n}\n\nfragment CashbackCell_cashback on Cashback {\n  id\n  date\n  name\n  rate\n  place\n  storeId\n  amount\n  source\n  plaidTransactionId\n  transactionAmount\n  state\n  quarantinedReason\n  availableStates\n}\n\nfragment CashbackShow_cashback on Cashback {\n  id\n  date\n  name\n  rate\n  amount\n  source\n  pended\n  plaidTransactionId\n  transactionAmount\n  fastCashId\n  state\n  quarantinedReason\n  availableStates\n  userAuth0Id\n}\n\nfragment FastCashContainer_fastCash on FastCash {\n  id\n  lifetimeCash\n  availableCash\n  pendingCash\n  specialCashbackRate {\n    id\n    fastCashId\n    userId\n    comment\n    state\n    cashbackRate\n    createdAt\n    updatedAt\n    deletedAt\n  }\n  firstOnboardedAt\n  blockedState\n  transactionsData(afterDate: $afterDate, beforeDate: $beforeDate, stateEq: $stateEq, bankAccountIdEq: $bankAccountIdEq, storeIdEq: $storeIdEq, integrationItemIdEq: $integrationItemIdEq, nameCont: $nameCont, byMerchantNames: $byMerchantNames, nameNotIContAll: $nameNotIContAll) {\n    transactionsCount\n    depositsAmount\n    expensesAmount\n  }\n  cashbacksData(afterDate: $afterDate, beforeDate: $beforeDate) {\n    netCashbacksAmount\n    spentCashbacksAmount\n    earnedCashbacksAmount\n    refundCashbacksAmount\n  }\n  integrationItems {\n    id\n    institutionName\n    itemId\n    state\n    errorCode\n    accountOnboardedAt\n  }\n  user {\n    email\n    referrer {\n      fullName\n      auth0Id\n      id\n    }\n    invitedUsers {\n      auth0Id\n      fullName\n      id\n    }\n    id\n  }\n  cashbacks(afterDate: $afterDate, beforeDate: $beforeDate) {\n    id\n    name\n    amount\n    state\n    date\n    quarantinedReason\n    availableStates\n    storeId\n    place\n    ...CashbackCell_cashback\n  }\n  bankAccounts {\n    id\n    name\n    duplicationState\n    plaidAccountId\n    availableDuplicationStates\n    bankAccountsWithMask {\n      id\n    }\n    integrationItem {\n      institutionName\n      id\n    }\n    ...BankAccountCell_bankAccount\n  }\n  checkIns(afterDate: $afterDate, beforeDate: $beforeDate) {\n    id\n    createdAt\n  }\n  latestMembershipState\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e33c6d515aebe9b12c07dcc25608db6a';

module.exports = node;
